import { useQuery } from '@tanstack/react-query';
import api from '../../api/client';
import { queryClient } from '../queryClient';
import { queryKeys } from './queryKeys';

export function findGroupInBootstrap(bootstrap, groupId) {
  if (!bootstrap || !groupId) return null;

  for (const section of bootstrap.sections || []) {
    const refData = section?.refData;
    if (refData?.id === groupId) return refData;

    for (const group of section?.items || []) {
      if (group?.id === groupId) return group;
    }
  }

  return null;
}

export async function fetchPresetGroups(signal) {
  const res = await api.get('/preset-groups', { signal });
  return Array.isArray(res?.data?.groups) ? res.data.groups : [];
}

export function seedPresetGroup(group) {
  if (!group?.id) return;
  queryClient.setQueryData(queryKeys.presetGroup(group.id), group);
}

export function usePresetGroupQuery(groupId, { initialGroup = null, enabled = true } = {}) {
  return useQuery({
    queryKey: queryKeys.presetGroup(groupId),
    queryFn: async ({ signal }) => {
      const groups = await fetchPresetGroups(signal);
      return groups.find((group) => group?.id === groupId) || null;
    },
    enabled: enabled && Boolean(groupId),
    initialData: initialGroup || undefined,
    initialDataUpdatedAt: initialGroup ? Date.now() : undefined,
  });
}
